var map = {
	"./halacska.png": 2046,
	"./halacska/1.jpg": 1278,
	"./halacska/2.jpg": 3769,
	"./halacska/3.jpg": 44,
	"./katica.png": 2097,
	"./katica/1.jpg": 4313,
	"./katica/10.jpg": 645,
	"./katica/11.jpg": 7128,
	"./katica/2.jpg": 9294,
	"./katica/3.jpg": 5131,
	"./katica/4.jpg": 1528,
	"./katica/5.jpg": 2709,
	"./katica/6.jpg": 2218,
	"./katica/7.jpg": 4375,
	"./katica/8.jpg": 6900,
	"./katica/9.jpg": 4273,
	"./margareta.png": 2868,
	"./margareta/1.jpg": 3744,
	"./margareta/10.jpg": 6154,
	"./margareta/2.jpg": 1119,
	"./margareta/3.jpg": 9410,
	"./margareta/4.jpg": 4641,
	"./margareta/5.jpg": 2836,
	"./margareta/6.jpg": 8899,
	"./margareta/7.jpg": 8790,
	"./margareta/8.jpg": 5605,
	"./margareta/9.jpg": 1288,
	"./napocska.png": 2130,
	"./napocska/1.jpg": 6898,
	"./napocska/10.jpg": 4064,
	"./napocska/11.jpg": 6285,
	"./napocska/12.jpg": 354,
	"./napocska/13.jpg": 8415,
	"./napocska/2.jpg": 9037,
	"./napocska/3.jpg": 1936,
	"./napocska/4.jpg": 6739,
	"./napocska/5.jpg": 2038,
	"./napocska/6.jpg": 3457,
	"./napocska/7.jpg": 4932,
	"./napocska/8.jpg": 2935,
	"./napocska/9.jpg": 3930,
	"./pillango.png": 546,
	"./pillango/1.jpg": 3458,
	"./pillango/10.jpg": 5696,
	"./pillango/11.jpg": 2797,
	"./pillango/12.jpg": 658,
	"./pillango/13.jpg": 655,
	"./pillango/14.jpg": 8692,
	"./pillango/2.jpg": 2685,
	"./pillango/3.jpg": 7792,
	"./pillango/4.jpg": 6595,
	"./pillango/5.jpg": 6486,
	"./pillango/6.jpg": 8689,
	"./pillango/7.jpg": 8151,
	"./pillango/8.jpg": 8967,
	"./pillango/9.jpg": 1226,
	"./suni.png": 7379,
	"./suni/1.jpg": 7007,
	"./suni/2.jpg": 1011,
	"./suni/3.jpg": 2621,
	"./suni/4.jpg": 1158,
	"./suni/5.jpg": 4323,
	"./tulipan.png": 2435,
	"./tulipan/1.jpg": 3471,
	"./tulipan/10.jpg": 7103,
	"./tulipan/11.jpg": 722,
	"./tulipan/12.jpg": 4877,
	"./tulipan/13.jpg": 6784,
	"./tulipan/14.jpg": 6947,
	"./tulipan/15.jpg": 2182,
	"./tulipan/16.jpg": 4321,
	"./tulipan/2.jpg": 5472,
	"./tulipan/3.jpg": 7693,
	"./tulipan/4.jpg": 8614,
	"./tulipan/5.jpg": 1747,
	"./tulipan/6.jpg": 2036,
	"./tulipan/7.jpg": 6369,
	"./tulipan/8.jpg": 8906,
	"./tulipan/9.jpg": 1095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4630;